import { Col, Container, Row } from "reactstrap"
import styles from "./FinanceOverview.module.scss"

const FinanceOverview = () => {
  const overviewData = [
    { period: "Today", totalSales: "$500", totalEarnings: "$450", pendingPayments: "$450", estimatedFutureSales: "$600" },
    { period: "This Week", totalSales: "$2,500", totalEarnings: "$2,200", pendingPayments: "$2,200", estimatedFutureSales: "$3,000" },
    { period: "This Month", totalSales: "$10,000", totalEarnings: "$8,500", pendingPayments: "$8,500", estimatedFutureSales: "$12,000" },
  ]

  const recentTransactionsData = [
    { type: "Sale", orderId: "Order #45678", productDetails: "Blue colored headphones", amount: "$600", status: "Completed" },
    { type: "Refund", orderId: "Order #45678", productDetails: "Blue colored headphones", amount: "$3,000", status: "Completed" },
  ]

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <h4 className="fw-semibold mb-3">Overview</h4>

        <div className="px-4">
          <Row className={styles.headOrange}>
            <Col>Period</Col>
            <Col>Total Sales</Col>
            <Col>Total Earnings</Col>
            <Col>Pending Payments</Col>
            <Col>Estimated Future Sales</Col>
          </Row>
          {overviewData.map((item) => (
            <Row className={styles.row}>
              <Col className={styles.column}>{item.period}</Col>
              <Col className={styles.column}>{item.totalSales}</Col>
              <Col className={styles.column}>{item.totalEarnings}</Col>
              <Col className={styles.column}>{item.pendingPayments}</Col>
              <Col className={styles.column}>{item.estimatedFutureSales}</Col>
            </Row>
          ))}
        </div>

        <h4 className="fw-semibold my-3">Recent Transaction</h4>
        <div className="px-4">
          <Row className={styles.headGray}>
            <Col>Type</Col>
            <Col>Order ID</Col>
            <Col>Product details</Col>
            <Col>Amount</Col>
            <Col>Status</Col>
          </Row>
          {recentTransactionsData.map((item) => (
            <Row className={styles.recentTransactionsDataRow}>
              <Col className={styles.recentTransactionsDataColumn}>{item.type}</Col>
              <Col className={styles.recentTransactionsDataColumn}>{item.orderId}</Col>
              <Col className={styles.recentTransactionsDataColumn}>{item.productDetails}</Col>
              <Col className={styles.recentTransactionsDataColumn}>{item.amount}</Col>
              <Col className={styles.recentTransactionsDataColumn}>{item.status}</Col>
            </Row>
          ))}
        </div>
      </Container>
    </div>
  )
}

export default FinanceOverview
